module.exports = __webpack_public_path__ + "static/media/teamsMedium.ecc1db59.svg";